export { getAnalytics, provideAnalytics } from './providers';
export { Analytics } from './tokens';

/** No-op stand-ins for former @angular/fire analytics tracking services. */
export class ScreenTrackingService {}
export class UserTrackingService {}
